import RemoveUsersFormContainer from './RemoveUsersFormContainer';

export default RemoveUsersFormContainer;
